"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * remove a subString from a string
 *
 * @returns replacementStr
 * @example
 * removeSubString("There is no curse in Elvish, Entish, or the tongues of Orcs for this treachery.", "Orcs", "Men")  =>
 * 'There is no curse in Elvish, Entish, or the tongues of Men for this treachery.'
 */
var removeSubString = function removeSubString(str) {
  var subStrToRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var replacementStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if ((0, _isNotString.default)(str)) return '';
  return str.replace(subStrToRemove, replacementStr).trim();
};

var _default = removeSubString;
exports.default = _default;